import produce from 'immer';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import { THEME_AND_SETTINGS_FETCHED, FETCH_THEME_SUCCEEDED } from '../actions/ActionTypes';

// TODO use types/api/Theme type here instead of manually syncing the types

const DEFAULT_DATA = {};
const themeReducer = (state = DEFAULT_DATA, action) => produce(state, draft => {
  switch (action.type) {
    case THEME_AND_SETTINGS_FETCHED:
    case FETCH_THEME_SUCCEEDED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return draft;
        }
        //@ts-expect-error we should change key in CEUI to payload and remove this
        const payload = action.payload || action.response;
        draft = payload.theme;
        return draft;
      }
    default:
      return draft;
  }
});
export default themeReducer;